import { render } from "./RealRegDocument.vue?vue&type=template&id=b35b0a6c&scoped=true"
import script from "./RealRegDocument.vue?vue&type=script&lang=js"
export * from "./RealRegDocument.vue?vue&type=script&lang=js"

import "./RealRegDocument.vue?vue&type=style&index=0&id=b35b0a6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35b0a6c"]])

export default __exports__